import { IS_DEVELOPMENT } from '../../config/env';
const DEFAULT_TITLE = 'Maintella';

function buildDocumentTitle(pageTitle = '') {
  const fullTitle = pageTitle
    ? `${pageTitle} | ${DEFAULT_TITLE}`
    : DEFAULT_TITLE;

  const isLocalDev = IS_DEVELOPMENT;

  return isLocalDev ? `LOCAL: ${fullTitle}` : fullTitle;
}

export function applyDocumentTitle(pageTitle = '') {
  document.title = buildDocumentTitle(pageTitle);
}
